import script from "./not-found.vue?vue&type=script&setup=true&lang=js"
export * from "./not-found.vue?vue&type=script&setup=true&lang=js"

export default script